module.exports = __webpack_public_path__ + "img/fourday1-2.fa5fcc4d.jpg";